import { render } from "./tabs-menu.layout.vue?vue&type=template&id=1887fb8c"
import script from "./tabs-menu.layout.vue?vue&type=script&lang=js"
export * from "./tabs-menu.layout.vue?vue&type=script&lang=js"

import exportComponent from "/Users/ohirjak/projects/mov-vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__